const { TableRow, TableCell, Skeleton } = require("@mui/material")


const SurveySkeleton = ({ numberOfRows }) => (
    <TableRow>
        {
            [...Array(numberOfRows)].map((el, index) => {
                return (
                    <TableCell key={index}>
                        <Skeleton variant='rectangular' />
                    </TableCell>
                )
            })
        }
    </TableRow>
)

export default SurveySkeleton;